const picAnalysis = {
  video: null,
  canvas: null,
  overlay: null,
  constraints: null,
  regionSelected: false,
  startX: 0,
  startY: 0,
  endX: 0,
  endY: 0,
  emit: null,
  croppedCanvas: null,
  hasGetUserMedia(){
    return navigator.mediaDevices &&
      navigator.mediaDevices.getUserMedia;
  },
  init(){	
    picAnalysis.video = document.querySelector("#video");
    picAnalysis.canvas = document.querySelector("#canvas");
    picAnalysis.overlay = document.querySelector(".overlay");
    picAnalysis.constraints = {
      video: { facingMode: "environment" }
    };

    // 創建一個 Image 物件
		// var img = new Image();
		// img.src = require('@/assets/images/logo/test.png');
		// img.onload = function() {
		// 	picAnalysis.canvas.getContext('2d').drawImage(img, 0, 0);
		// }

    // var img = new Image();
    // img.src = require('@/assets/images/logo/test.png');
    // img.onload = function() {
    //   var canvas = picAnalysis.canvas;
    //   var context = canvas.getContext('2d');
    //   var canvasWidth = canvas.width;
    //   var canvasHeight = canvas.height;
    //   var imageWidth = img.width;
    //   var imageHeight = img.height;
    //   var x = (canvasWidth - imageWidth) / 2;
    //   var y = (canvasHeight - imageHeight) / 2;
    //   context.drawImage(img, x, y);
    // }

    if(picAnalysis.hasGetUserMedia()){
      navigator.mediaDevices.getUserMedia(picAnalysis.constraints)
        .then(function (stream) {
          picAnalysis.video.srcObject = stream;
          picAnalysis.video.play();
        }) 
        .catch(function (err) {
          console.log("Error:", err);
        });
        
      picAnalysis.video.addEventListener("loadedmetadata", () => {
          picAnalysis.video.width = picAnalysis.canvas.width;
          picAnalysis.video.height = picAnalysis.canvas.height;
        });       
    }
      
  },
  sendToGoogleAPI(base64Image){
    let apiKey = "AIzaSyDm23zyuxztNJdR3oRbylK3-CKQ6wCFxBg";
    let url = "https://vision.googleapis.com/v1/images:annotate?key=" + apiKey;
  
    let data = {
      "requests": [
        {
          "image": {
            "content": base64Image
          },
          "features": [
            {
              "type": "TEXT_DETECTION"
            }
          ],
          "imageContext": {
            "cropHintsParams": {
              "aspectRatios": [1]
            }
          }
        }
      ]
    }

    let xhr = new XMLHttpRequest();
    xhr.onload = function() {
      if (xhr.status === 200) {
        let response = JSON.parse(xhr.responseText);
        let textAnnotations = response.responses[0].textAnnotations;
        if (textAnnotations && textAnnotations.length > 0) {
          let parsedText = textAnnotations[0].description;
          document.querySelector("#textResult").value = parsedText;
          picAnalysis.emit('change', parsedText)
        } else {
          console.log("No text found.");
          alert("No text found.");
        }
      } else {
        console.log("Google Cloud Vision API error:", xhr.status);
        alert("Google Cloud Vision API error:", xhr.status);
      }
    };
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(data));
  },
  getTouchPos(e){
    const rect = e.target.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const y = e.touches[0].clientY - rect.top;
    return { x, y };
  },
  handleTouchStart(e){
    e.preventDefault();
    const { x, y } = picAnalysis.getTouchPos(e);
    console.log("("+x+","+ y+")" );
    picAnalysis.startX = x;
    picAnalysis.startY = y;
    picAnalysis.canvas.addEventListener("touchmove", picAnalysis.handleTouchMove);
  },
  handleTouchMove(e){
    e.preventDefault();
    const { x, y } = picAnalysis.getTouchPos(e);
  
    picAnalysis.endX = x;
    picAnalysis.endY = y;
    let width = picAnalysis.endX - picAnalysis.startX;
    let height = picAnalysis.endY - picAnalysis.startY;
    picAnalysis.overlay.style.left = picAnalysis.startX + "px";
    picAnalysis.overlay.style.top = picAnalysis.startY + "px";
    picAnalysis.overlay.style.width = width + "px";
    picAnalysis.overlay.style.height = height + "px";
    picAnalysis.overlay.style.display = "block";
    picAnalysis.regionSelected = true;      
  },
  handleTouchEnd(e){	

    e.preventDefault();
    picAnalysis.canvas.removeEventListener("touchmove", picAnalysis.handleTouchMove);
  
    if (picAnalysis.regionSelected) {
      // drawCroppedImage(picAnalysis.startX, picAnalysis.startY, picAnalysis.endX, picAnalysis.endY);    
    }
  },
  recognize(){ 
    let imageData = picAnalysis.canvas.getContext("2d").getImageData(
      picAnalysis.startX, 
      picAnalysis.startY,
      picAnalysis.endX - picAnalysis.startX, 
      picAnalysis.endY - picAnalysis.startY 
    );
    picAnalysis.croppedCanvas = document.createElement("canvas");
    picAnalysis.croppedCanvas.width = picAnalysis.endX - picAnalysis.startX;
    picAnalysis.croppedCanvas.height = picAnalysis.endY - picAnalysis.startY;
    picAnalysis.croppedCanvas.getContext("2d").putImageData(imageData, 0, 0);
    

    document.querySelector('.pic-ana').appendChild(picAnalysis.croppedCanvas)
    
    picAnalysis.canvas.removeEventListener("touchstart", picAnalysis.handleTouchStart);
    picAnalysis.canvas.removeEventListener("touchmove", picAnalysis.handleTouchMove);
    picAnalysis.canvas.removeEventListener("touchend", picAnalysis.handleTouchEnd);

    if (picAnalysis.croppedCanvas) {
      let base64Image = picAnalysis.croppedCanvas.toDataURL("image/png").replace("data:image/png;base64,", "");
      picAnalysis.sendToGoogleAPI(base64Image);
    } else {
      alert("Please select a region first.");
      return;
    }
    
    //clear picAnalysis.canvas
    picAnalysis.canvas.getContext("2d").clearRect(0, 0, picAnalysis.canvas.width, picAnalysis.canvas.height);	  
    
      // Hide overlay and display video element
    picAnalysis.overlay.style.display = "none";
    picAnalysis.video.style.display = "block";

    // Play video
    picAnalysis.video.play();
  },
  capture(){
    picAnalysis.video.pause();
    picAnalysis.canvas.style.display = "block";
    // picAnalysis.canvas.width = picAnalysis.video.videoWidth;
    // picAnalysis.canvas.height = picAnalysis.video.videoHeight;
    picAnalysis.canvas.getContext("2d").drawImage(picAnalysis.video, 0, 0, picAnalysis.canvas.width, picAnalysis.canvas.height);
    picAnalysis.overlay.style.display = "none";
    picAnalysis.regionSelected = false;
    picAnalysis.canvas.addEventListener("touchstart", picAnalysis.handleTouchStart);
    picAnalysis.canvas.addEventListener("touchmove", picAnalysis.handleTouchMove);
    picAnalysis.canvas.addEventListener("touchend", picAnalysis.handleTouchEnd);

    if(picAnalysis.croppedCanvas){
      document.querySelector('.pic-ana').removeChild(picAnalysis.croppedCanvas)
      picAnalysis.croppedCanvas = null
    }
  }
}


export default picAnalysis
